module.exports = __webpack_public_path__ + "img/icon_enlarge.7c814f02.svg";